<greco-simple-dialog [data]="dialogData">
  <greco-box #ngTextContent>
    <span [innerHtml]="agreementText | safe:'html'"></span>
  </greco-box>
</greco-simple-dialog>
